import * as React from 'react';
import { LocationPickerButton, LocationPickerModal } from '../../../../components/Filters';
import { useEventCallback } from '@cian/react-utils';
import { EBuildersLocationsStatus } from '../../../../types/buildersLocations';
import { useLocationSearch, useLocations } from './hooks';
import { useDispatch, useSelector } from 'react-redux';
import { TThunkDispatch } from '../../../../types/redux';
import { selectLocationName, selectLocationsStatus } from '../../../../selectors/locations';
import { fetchLocations } from '../../../../actions/buildersLocations';
import { changeLocation } from '../../../../actions/filters';

export const LocationPickerContainer = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const [modalOpened, setModalOpened] = React.useState(false);
  const status = useSelector(selectLocationsStatus);
  const name = useSelector(selectLocationName);
  const { favorites, columns } = useLocations();
  const { searchQuery, handleLocationSearch, suggestions } = useLocationSearch();

  React.useEffect(() => {
    if (status !== EBuildersLocationsStatus.Initial || !modalOpened) {
      return;
    }

    dispatch(fetchLocations());
  }, [dispatch, status, modalOpened]);

  const handleLocationSelect = useEventCallback((locationId: number) => {
    dispatch(changeLocation(locationId));
    setModalOpened(false);
  });

  const openModal = useEventCallback(() => {
    handleLocationSearch('');
    setModalOpened(true);
  });

  return (
    <div>
      <LocationPickerButton onClick={openModal}>{name}</LocationPickerButton>
      <LocationPickerModal
        opened={modalOpened}
        loading={status !== EBuildersLocationsStatus.Success}
        searchQuery={searchQuery}
        locationsFavorites={favorites}
        locationsColumns={columns}
        locationsSuggestions={suggestions}
        onClose={() => setModalOpened(false)}
        onLocationSelect={handleLocationSelect}
        onLocationSearch={handleLocationSearch}
      />
    </div>
  );
};
